export type TokenName =
  | `${'brand' | 'gray' | 'success' | 'error' | 'warning' | 'blue-light' | 'orange'}-${25 | 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950}`
  | 'theme-purple-500'
  | 'theme-pink-500'
  | 'surface-raised';

/** Resolves `--color-<name>` from :root at call time. Client only. */
export function themeColor(name: TokenName): string {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--color-${name}`)
    .trim();
  if (!value)
    throw new Error(
      `Unknown theme color token "${name}": --color-${name} is not defined in styles/tailwind.css`,
    );
  return value;
}
